import React from 'react';
import PropTypes from 'prop-types';

const Input = ({
  onChange,
  label,
  name,
  placeholder,
  value,
  type,
  autoComplete,
  autoFocus,
  required,
  textError
}) => {
  const hasError = textError.length > 0;
  return (
    <div className="form-group">
      <div className="required">
        <label htmlFor="#">{label}</label>
        <input
          className={`${hasError ? 'form-control has-error' : 'form-control'}`}
          autoFocus={autoFocus}
          autoComplete={autoComplete}
          type={type}
          placeholder={placeholder}
          name={name}
          onChange={onChange}
          value={value}
          required={required}
        />
      </div>
      <span className="text-error-utils">{textError}</span>
    </div>
  );
};

Input.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.string,
  type: PropTypes.string.isRequired,
  autoComplete: PropTypes.string,
  autoFocus: PropTypes.bool,
  required: PropTypes.bool,
  textError: PropTypes.string
};

Input.defaultProps = {
  textError: ''
};

export default Input;



// WEBPACK FOOTER //
// ./src/modules/signupForm/components/Input/Input.js